const _require = require('@truqc/content-path'),
  keysSortedByValueAscending = _require.keysSortedByValueAscending;
const _require2 = require('../../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evaluate - evaluate benhurPercentCompleteBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const combined = (await evaluateSource(source.combined, content, parentContentPath, transientContext, nativeFunctions)) || {};
  const result = {};
  const laborKeys = keysSortedByValueAscending(combined);
  for (let laborIndex = 0; laborIndex < laborKeys.length; laborIndex += 1) {
    const laborKey = laborKeys[laborIndex];
    const _combined$laborKey = combined[laborKey],
      laborTitle = _combined$laborKey.title,
      laborCreated = _combined$laborKey._created,
      children = _combined$laborKey.children;
    const activityKeys = keysSortedByValueAscending(children);
    for (let activityIndex = 0; activityIndex < activityKeys.length; activityIndex += 1) {
      const activityKey = activityKeys[activityIndex];
      const _children$activityKey = children[activityKey],
        activityTitle = _children$activityKey.title,
        activityCreated = _children$activityKey._created,
        unitsTypes = _children$activityKey.unitsTypes;
      result["".concat(laborKey, "_").concat(activityKey)] = {
        _created: laborIndex * 1000 + activityIndex,
        laborActivity: {
          [laborKey]: {
            title: laborTitle,
            _created: laborCreated,
            children: {
              [activityKey]: {
                title: activityTitle,
                _created: activityCreated,
                unitsTypes
              }
            }
          }
        }
      };
    }
  }
  return result;
};
module.exports = {
  evaluate
};